import React from 'react';
import { RssStatus } from '../useAdminQueues';

interface RssStatusBlockProps {
  rssStatus: RssStatus | null;
  onToggle: () => void;
}

/** Superadmin: RSS auto-refresh status + pause/resume. */
const RssStatusBlock: React.FC<RssStatusBlockProps> = ({ rssStatus, onToggle }) => {
  if (!rssStatus) return null;
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="tend-micro">RSS Auto-Refresh</span>
        <span
          title={rssStatus.paused ? 'Paused' : 'Active'}
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: rssStatus.paused ? 'var(--signal-rec-soft)' : 'var(--signal-live)',
            boxShadow: rssStatus.paused ? 'none' : '0 0 8px rgba(68,211,106,.7)',
          }}
        />
        <button
          type="button"
          className="tend-btn tend-btn--glass"
          style={{ marginLeft: 'auto', padding: '4px 12px', fontSize: 12 }}
          onClick={onToggle}
        >
          {rssStatus.paused ? 'Resume' : 'Pause'}
        </button>
      </div>
      <p style={{ margin: '6px 0 0', fontSize: 12, color: 'var(--text-3)' }}>
        {rssStatus.paused
          ? 'Feed refresh paused — no new articles will be fetched.'
          : 'Checking feeds every 60s for updates.'}
      </p>
    </div>
  );
};

export default RssStatusBlock;
